/* CRADRI: isolated legacy collaboration LP slideshow recovery.
   Runs only on legacy page handles explicitly mapped in layout/lp.liquid.
   The working /pages/manosaba and standard Prestige pages are untouched. */
(function () {
  'use strict';
  var script = document.currentScript;
  if (!script) return;
  var jqueryUrl = script.getAttribute('data-jquery-url');
  var slickUrl = script.getAttribute('data-slick-url');

  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      if (!url) return reject(new Error('No script URL'));
      var s = document.createElement('script');
      s.src = url;
      s.onload = resolve;
      s.onerror = function () { reject(new Error('Could not load ' + url)); };
      document.head.appendChild(s);
    });
  }

  function initSlick($) {
    var candidates = [
      ['.slider--box', {autoplay:true, autoplaySpeed:0, speed:5000, cssEase:'linear', slidesToShow:1, arrows:false, swipe:false, pauseOnFocus:false, pauseOnHover:false}],
      ['.slideshow-container', {fade:true, slidesToShow:1, slidesToScroll:1, autoplay:true, autoplaySpeed:4000}],
      ['.slideshow-container2', {fade:true, slidesToShow:1, slidesToScroll:1, autoplay:true, autoplaySpeed:4000}],
      ['.topMv--slider', {fade:true, autoplay:true, autoplaySpeed:5000, speed:2000, arrows:false, dots:false}],
      ['.topColabo--slider', {autoplay:true, dots:true, slidesToShow:3, slidesToScroll:3, responsive:[{breakpoint:768,settings:{centerMode:true,centerPadding:'10%',slidesToShow:1,slidesToScroll:1}}]}],
      ['.aboutMaking--slider', {arrows:false, autoplay:true, autoplaySpeed:3000, speed:1000, adaptiveHeight:true, centerMode:true, centerPadding:'30%', responsive:[{breakpoint:768,settings:{centerPadding:'10%'}}]}],
      ['.usadapekora--slider--box', {autoplay:true, autoplaySpeed:0, speed:5000, cssEase:'linear', slidesToShow:3, arrows:false, swipe:false, pauseOnFocus:false, pauseOnHover:false}]
    ];
    candidates.forEach(function (entry) {
      $(entry[0]).each(function () {
        if ($(this).hasClass('slick-initialized') || $(this).children().length < 2) return;
        try { $(this).slick(entry[1]); }
        catch (err) { console.warn('[CRADRI legacy LP] slider init failed', err); }
      });
    });
  }

  function start() {
    // No jquery/slick download on pages without old-style galleries.
    var candidate = document.querySelector('.slider--box, .slideshow-container, .slideshow-container2, .topMv--slider, .topColabo--slider, .aboutMaking--slider, .usadapekora--slider--box');
    if (!candidate) return;
    var ready = window.jQuery ? Promise.resolve() : loadScript(jqueryUrl);
    ready.then(function () {
      if (!window.jQuery) throw new Error('jQuery unavailable');
      return typeof window.jQuery.fn.slick === 'function' ? Promise.resolve() : loadScript(slickUrl);
    }).then(function () {
      if (window.jQuery && typeof window.jQuery.fn.slick === 'function') initSlick(window.jQuery);
    }).catch(function (error) {
      console.warn('[CRADRI legacy LP] Slideshow fallback unavailable:', error);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
